<template>
  <AdminLayout v-model:activeTab="view">
    <div v-if="view === 'reporte_produccion'"><ReporteProduccion /></div>
  </AdminLayout>
</template>

<script setup>
import { ref } from "vue";
import AdminLayout from "@/components/Layout/AdminLayout.vue";
import ReporteProduccion from "@/components/Inyeccion/ReporteProduccion.vue";

const view = ref("reporte_produccion");
</script>
